<template>
  <div ref="pageView" class="page-view pd-lr-20 container-view">
    <section class="title-section fixed-view">
      <e6-title>
        车辆停车汇总表
        <template slot="operate">
          <el-button
            class="g-form-section-search operate__item"
            title="表格列设置"
            icon="e6-icon-field_line"
            @click="columSetVisible = !columSetVisible"
            plain
          ></el-button>
          <el-button
            class="g-form-section-search operate__item"
            title="导出"
            v-if="operationSuper.导出"
            icon="e6-icon-export_line"
            @click="handleExportClick"
            plain
          ></el-button>
          <el-button
            class="g-form-section-search operate__item"
            :class="{ 'is-open': !isSearch }"
            icon="e6-icon-search_line"
            @click="handleIsSearch"
            plain
          ></el-button>
        </template>
      </e6-title>
    </section>
    <!-- title end -->
    <!-- 查询条件 -->
    <section class="g-form-section form-section fixed-view" :hidden="isSearch">
      <e6-form-extend
        class="form-extend e6-form--validate"
        :class="{ 'is-open': isSearch }"
        :formExtend="formExtend"
        @submitForm="handlesSubmitForm"
        @resetForm="handleResetForm"
      >
        <template slot-scope="slotForms">
          <el-form-item
            prop="timeRange"
            label="停车开始时间"
            label-width="120px"
          >
            <el-date-picker
              v-model="timeRange"
              type="datetimerange"
              unlink-panels
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="datePickerOptions"
              :default-time="['00:00:00', '23:59:59']"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item prop="forms.alarmNameType">
            <e6Select
              :dataList="vehicleList"
              :filterable="true"
              slotTemplate="tree"
              :issingleleaf="true"
              :disabledNoCheck="false"
              multiple
              ref="vehicleTreeSelect"
              :placeholder="'车辆'"
              @multipleSelect="selVehicle"
            ></e6Select>
          </el-form-item>
          <el-form-item prop="forms.transType">
            <dict-select
              style="width:220px"
              v-model="slotForms.forms.transType"
              placeholder="请选择运输类型"
              :pkey="'trans_type'"
              :multiple="true"
            ></dict-select>
          </el-form-item>
        </template>
        <template slot="submit">查询</template>
        <template slot="reset">重置</template>
      </e6-form-extend>
    </section>
    <!-- 查询条件 end -->
    <!-- 表格 -->
    <section class="table-section" :style="{ height: resizeViewHeight + 'px' }">
      <el-table
        v-loading="tableLoading"
        ref="multipleTable"
        border
        :data="tableData"
        height="100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          label="序号"
          width="80"
          fixed
          type="index"
        ></el-table-column>
        <el-table-column
          v-for="(item, index) in localShowTableCols"
          :key="index"
          :show-overflow-tooltip="true"
          min-width="170"
          align="center"
          :prop="item.name"
          :label="item.title"
        ></el-table-column>
        <el-table-column align="center" label="操作" width="120" fixed="right">
          <template slot-scope="{ row }">
            <router-link
              :to="{
                path: '/vehicleStopDetailList',
                query: {
                  vehicleIdList: row.vehicleId,
                  beginTime: row.beginTime,
                  transType: formExtend.forms.transType,
                  endTime: row.endTime
                }
              }"
              >查看明细</router-link
            >
          </template>
        </el-table-column>
      </el-table>
    </section>
    <!-- 表格 end -->
    <!-- 翻页 -->
    <section class="pagination-section fixed-view">
      <e6-pagination
        :total="total"
        :pageSize.sync="pageSize"
        :currentPage.sync="curPage"
        @currentChange="handleCurrentChange"
        @sizeChange="handleSizeChange"
      ></e6-pagination>
    </section>
    <!-- 翻页 end -->
    <!-- 表格列设置 -->
    <e6-column-set
      @setColumnSubmit="handleSetColumnSubmit"
      @setColumnCancel="handleSetColumnCancel"
      :columSetVisible.sync="columSetVisible"
      :hideTableCols.sync="copyHideTableCols"
      :showTableCols.sync="copyShowTableCols"
    ></e6-column-set>
    <!-- 表格列设置 end -->
  </div>
</template>

<script>
import { FetchVehicleStopByPage } from "@/api/report/vehicle";
import { FetchVehicleTree } from "@/api/base/vehicle";
import { mapActions } from "vuex";
import listInit from "@/mixins/listInit";

import operationManage from "_private/mixins/operationManage";
import { mergeFormExtend } from "_private/utils/merge";
import { datePickerOptionsNotContainToday } from "@/utils/dateUtil.js";
// import { exportXlsx } from "@/utils/exportXlsx.js";
import moment from "moment";

export default {
  mixins: [listInit, operationManage],
  data() {
    return {
      dataType: "object",
      isSearch: false,
      vehicleList: [], // 车辆下拉数据源
      timeRange: [
        moment()
          .subtract(1, "day")
          .startOf("day")
          .format("YYYY-MM-DD HH:mm:ss"),
        moment()
          .subtract(1, "day")
          .endOf("day")
          .format("YYYY-MM-DD HH:mm:ss")
      ],
      formExtend: {
        forms: {
          beginTime: "",
          endTime: "",
          vehicleIdList: [],
          transType: []
        },
        extends: []
      },
      formsExtend: [],
      tableData: [],
      // 表格列相关
      columSetVisible: false,
      multipleSelection: [],
      datePickerOptions: datePickerOptionsNotContainToday,
      // 请求表格数据
      tableDataUrl: "/report/stopVehicleSummary/findByPage",
      //导出URL
      exportUrl: "/report/stopVehicleSummary/exportStopVehicleSummaryReport?"
    };
  },

  created() {
    // 获取车辆下拉
    this.getVehicleList();
    this.setSearchFormIsOpenAct();
    this.initPage();
  },
  methods: {
    ...mapActions(["setSearchFormIsOpenAct"]),
    // 检验时间40天
    validataTime() {
      let start = moment(this.timeRange[0]);
      let end = moment(this.timeRange[1]);
      //判断时间间隔不能大于40天
      if (end.diff(start, "days") > 39) {
        this.$message.warning("开始时间与结束时间间隔不能大于40天！");
        return false;
      } else {
        return true;
      }
    },
    // 获取车辆下拉
    async getVehicleList() {
      try {
        let res = await FetchVehicleTree();
        if (res.result && Array.isArray(res.result)) {
          this.vehicleList = res.result;
        }
      } catch (err) {
        console.log(err);
      }
    },
    // 车辆选择的回调
    selVehicle(val) {
      this.formExtend.forms.vehicleIdList = [];
      if (val.length) {
        this.formExtend.forms.vehicleIdList = val.map(v => {
          return v.id;
        });
      }
    },
    // 请求列表数据
    getTableData() {
      try {
        return new Promise((resolve, reject) => {
          if (!this.timeRange) {
            this.$message.warning("开始时间与结束时间不能为空！");
            reject();
          }
          if (this.validataTime()) {
            FetchVehicleStopByPage(this.mergeObj())
              .then(response => {
                resolve(response);
              })
              .catch(error => {
                reject(error);
              });
          } else {
            this.tableLoading = false;
          }
        });
      } catch (error) {
        console.log(error);
      }
    },
    // 整合查询数据
    mergeObj() {
      if (this.timeRange) {
        this.formExtend.forms.beginTime = this.timeRange[0];
        this.formExtend.forms.endTime = this.timeRange[1];
      } else {
        this.formExtend.forms.beginTime = "";
        this.formExtend.forms.endTime = "";
      }
      return Object.assign({}, mergeFormExtend(this.formExtend), {
        pageParamVO: {
          curPage: this.curPage,
          pageSize: this.pageSize
        }
      });
    },
    // // 导出excel 表格
    // handleExport() {
    //   if (this.validataTime()) {
    //     let params = this.mergeObj();
    //     this.exportData(params);
    //   }
    // },
    // // 导出页面数据接口请求
    // async exportData(params) {
    //   try {
    //     exportVehicleStop(params).then(res => {
    //       // 导出
    //       exportXlsx(res, `车辆停车汇总表.xls`);
    //     });
    //   } catch (err) {
    //     console.log(err);
    //   }
    // },

    // 重置
    handleResetForm() {
      this.timeRange = [
        moment()
          .subtract(1, "day")
          .startOf("day")
          .format("YYYY-MM-DD HH:mm:ss"),
        moment()
          .subtract(1, "day")
          .endOf("day")
          .format("YYYY-MM-DD HH:mm:ss")
      ];
      this.$refs.vehicleTreeSelect.multipleRemoveAll();
      this.formExtend.forms.vehicleIdList = [];
    },
    //导出
    handleExportClick() {
      let param = "";
      if (this.timeRange !== null && this.timeRange !== "") {
        param += "&beginTime=" + this.timeRange[0];
        param += "&endTime=" + this.timeRange[1];
        param += "&vehicleIdList=" + this.formExtend.forms.vehicleIdList;
        param += "&transType=" + this.formExtend.forms.transType;
        document.location.href = this.exportUrl + param;
      } else {
        this.$message({
          showClose: true,
          message: "开始时间与结束时间不能为空！",
          type: "warning"
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.page-view {
  height: 100%;
}

.title-section {
  padding: 15px 0 10px;
}

.table-section {
  height: 200px;
}

.pagination-section {
  padding: 10px 0;
}

.batch-delete {
  line-height: 100px;
  text-align: center;
  background-color: #fff;
}

.links {
  color: #0000ff;
  cursor: pointer;
}

/deep/ .el-button--primary {
  .e6-icon-export_line,
  .e6-icon-set-up_line {
    color: #fff !important;
  }
}
/deep/ .el-table__body-wrapper {
  height: calc(100% - 36px) !important;
}
/deep/ .el-table__fixed-body-wrapper {
  height: calc(100% - 36px) !important;
  top: 36px !important;
}
</style>
